import * as React from "react";
const SvgCheckmark = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 256 256", ...props }, /* @__PURE__ */ React.createElement("g", { id: "Layer_2", "data-name": "Layer 2" }, /* @__PURE__ */ React.createElement("g", { id: "frame" }, /* @__PURE__ */ React.createElement("rect", { width: 256, height: 256, transform: "translate(256 256) rotate(-180)", style: {
  fill: "none"
} })), /* @__PURE__ */ React.createElement("g", { id: "mid" }, /* @__PURE__ */ React.createElement("polyline", { points: "216 66 95 187 40 132", style: {
  fill: "none",
  stroke: "#757d84",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 34
} }))));
export default SvgCheckmark;
